import {
  ApiListResponse,
  LeadSourceCreateDTO,
  LeadSourceDTO,
} from "@gymflow/types";
import { AxiosInstance } from "axios";

import { createSortParam } from "../createSortParam";
import { trimFields } from "./features/trimFiels";

export type LeadSourceApiType = ReturnType<typeof leadSourceApi>;

const leadSourceApi = (axiosInstance: AxiosInstance, clubId: number) => {
  const clubPrefix = `club/${clubId}/`;
  const fieldsToTrim = ["name"];

  return {
    find({
      page = 0,
      limit = 10,
      extraParams = {},
      sort,
    }: {
      readonly extraParams?: {
        readonly active?: boolean;
        readonly [k: string]: any;
      };
      readonly page?: number;
      readonly limit?: number;
      readonly sort?: {
        readonly field: string;
        readonly desc?: boolean;
      };
    }) {
      const config = {
        params: {
          page,
          size: limit,
          ...extraParams,
        },
      } as any;
      if (sort) {
        config.params.sort = createSortParam(sort);
      }
      return axiosInstance.get<ApiListResponse<LeadSourceDTO>>(
        `${clubPrefix}lead/source`,
        config,
      );
    },
    findById(id: number) {
      return axiosInstance.get<LeadSourceDTO>(`${clubPrefix}lead/source/${id}`);
    },
    create(newResource: LeadSourceCreateDTO) {
      return axiosInstance.post<LeadSourceDTO>(
        `${clubPrefix}lead/source`,
        trimFields(newResource, fieldsToTrim),
      );
    },
    update(id: number, patchedFields: Partial<LeadSourceCreateDTO>) {
      return axiosInstance.patch(
        `${clubPrefix}lead/source/${id}`,
        trimFields(patchedFields, fieldsToTrim),
      );
    },
    deactivate(id: number) {
      return axiosInstance.patch(`${clubPrefix}lead/source/${id}/inactive`);
    },
    activate(id: number) {
      return axiosInstance.patch(`${clubPrefix}lead/source/${id}/active`);
    },
  };
};

export default leadSourceApi;
